export default __webpack_public_path__ + "static/media/0592_DSC0870.fd96e38e.jpg";